<template>
  <CoreDialog
    v-model="isOpened"
    size="sm"
    data-qa="logout-dialog"
    :title="dialogLogout.title"
    attach
  >
    <template #default>
      <div class="text-body-1 text-secondary--text">
        {{ dialogLogout.text }}
      </div>
    </template>

    <template #actions>
      <v-btn
        v-if="dialogLogout.closeText"
        color="text"
        text
        data-qa="logout-dialog-cancel"
        @click="isOpened = false"
      >
        {{ dialogLogout.closeText }}
      </v-btn>
      <v-btn
        v-if="dialogLogout.confirmText"
        color="secondary"
        text
        data-qa="logout-dialog-confirm"
        @click="handleConfirm"
      >
        {{ dialogLogout.confirmText }}
      </v-btn>
    </template>
  </CoreDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import { getDialogLogout } from 'src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/SideMenu.constants'

const props = defineProps<{
  value: boolean
}>()

const dialogLogout = computed(() => getDialogLogout())

const emit = defineEmits<{(_event: 'input', _value: boolean): void
  (_event: 'confirm'): void
}>()

const isOpened = computed({
  get: () => props.value,
  set: (value: boolean) => emit('input', value),
})

function handleConfirm() {
  isOpened.value = false
  emit('confirm')
}
</script>
